import AlertSnackbar from "@/components/AlertSnackbar";
import { updateUser } from "@/services/api";
import { useCurrentUser } from "@/services/hooks";
import { Avatar, Box, Skeleton, Stack, TextField } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import debounce from "lodash/debounce";
import { useCallback, useEffect, useState } from "react";

export default function EditPreviewText() {
  const { data: currentUser, isLoading } = useCurrentUser();
  const queryClient = useQueryClient();

  const [value, setValue] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);

  const metaKey = "previewText";

  // Update state when currentUser data is loaded
  useEffect(() => {
    if (currentUser) {
      setValue(currentUser.meta?.[metaKey] || "");
    }
  }, [currentUser]);

  const mutation = useMutation({
    mutationFn: () => updateUser(null, { [metaKey]: value }),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["current_user"] });
      setShowSnackbar(true);
    },
  });

  const debouncedSave = useCallback(
    debounce((newValue) => {
      mutation.mutate();
    }, 1000),
    []
  );

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    debouncedSave(newValue);
  };

  if (isLoading) {
    return (
      <Skeleton
        variant="rectangular"
        height={56}
        width="100%"
        sx={{ borderRadius: "25px" }}
      />
    );
  }

  return (
    <Box sx={{ mt: 2 }}>
      <AlertSnackbar
        showSnackbar={showSnackbar}
        setShowSnackbar={setShowSnackbar}
      />
      <Stack direction="row" spacing={2}>
        <Avatar
          src={currentUser?.meta?.profile}
          sx={{ width: 40, height: 40 }}
        />
        <TextField
          placeholder="Welcome to my Notebook! Hope to see you inside."
          multiline
          value={value}
          fullWidth
          onChange={handleChange}
          disabled={mutation.isPending}
        />
      </Stack>
    </Box>
  );
}
